// UnitSelector.js
// Component for Selecting Unit

// Imports
import React from 'react';
import { MenuItem, Button } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';

// Component Class
// Shows Unit Selector
class UnitSelector extends React.Component {
  // Returns the name of the unit with the given id
  getUnitName = (id) => {
    return this.props.product.price[id].unit;
  };

  // Sets the unit with the given id as selected
  unitSelected = (id) => {
    this.props.setUnit(id);
  };

  // Validates an unit against a typeahead query
  unitPredicate = (query, id) => {
    var name = this.getUnitName(id);
    return name.toLowerCase().includes(query.toLowerCase());
  }

  // Renders a unit item on selector
  unitRenderer = (id, options) => {
    if (!options.modifiers.matchesPredicate) {
      return null;
    }
    return (
      <MenuItem
        active={options.modifiers.active}
        onClick={options.handleClick}
        key={id}
        text={this.getUnitName(id)}
      />
    );
  };

  // Renders Component
  render() {
    var empty = <MenuItem disabled text="Nenhuma unidade encontrada" />;
    var units = this.props.product.price.map((v, i) => i);
    var hasOrder = this.props.order && this.props.order[this.props.product.id];
    var disabled = units.length <= 1 || !hasOrder;
    var unitId = hasOrder ? this.props.order[this.props.product.id].unitId : 0;

    return (
      <Select
        items={units}
        itemRenderer={this.unitRenderer}
        inputValueRenderer={this.getClientName}
        itemPredicate={this.unitPredicate}
        noResults={empty}
        onItemSelect={this.unitSelected}
        filterable={false}
        disabled={disabled}
      >
        <Button 
          text={this.props.product.price[unitId].unit}
          disabled={!hasOrder}
          rightIcon="double-caret-vertical"
          fill
        />
      </Select>
    );
  }
}

// Required Properties
UnitSelector.propTypes = {
  product: PropTypes.object.isRequired,
  order: PropTypes.object,
  setUnit: PropTypes.func.isRequired,
}

// Exports
export default UnitSelector;


// WEBPACK FOOTER //
// ./src/components/OrderView/UnitSelector.js